// Copyright (c) StrangeBee 2023

import { THMenu } from '@Molecules/THMenu/THMenu';
import { Dropdown, DropDownProps } from 'antd';
import React, { ReactElement, ReactNode, useState } from 'react';
import { classList } from '@Helpers/className';

import './THDropdown.scss';

interface THDropdownProps {
    children: ReactNode;
    triggerElem: (visible: boolean) => ReactElement;
    trigger?: DropDownProps['trigger'];
    menuClassName?: string;
    dropdownClassName?: string;
    overlayClassName?: string;
    disabled?: boolean;
    placement?: DropDownProps['placement'];
    visible?: boolean;
    onVisibleChange?: (visible: boolean) => void;
    quitOnMenuItemClick?: boolean;
    align?: DropDownProps['align'];
}

export const THDropdown = ({
    children,
    triggerElem,
    trigger,
    menuClassName,
    disabled,
    placement,
    visible: propsVisible,
    onVisibleChange,
    overlayClassName,
    dropdownClassName,
    quitOnMenuItemClick = true,
    align,
}: THDropdownProps): ReactElement => {
    const [visible, setVisible] = useState(false);

    return !disabled ? (
        <Dropdown
            visible={propsVisible || visible}
            onVisibleChange={onVisibleChange || ((visible) => setVisible(visible))}
            overlay={
                <THMenu
                    className={menuClassName}
                    onClick={() => {
                        if (quitOnMenuItemClick) {
                            onVisibleChange?.(false) || setVisible(false);
                        }
                    }}
                >
                    {children}
                </THMenu>
            }
            overlayClassName={classList('th-dropdown', overlayClassName)}
            openClassName={dropdownClassName}
            trigger={trigger || ['hover']}
            placement={placement}
            align={align}
        >
            {triggerElem(propsVisible || visible)}
        </Dropdown>
    ) : (
        triggerElem(propsVisible || visible)
    );
};
